import { Container } from '@chronosphereio/chrono-ui';
import { PanelDefinition } from '../../../core';
import { PanelEditorValues } from '../../context';
import { Panel } from '../Panel';

const PANEL_PREVIEW_HEIGHT = 325;

export type PanelPreviewProps = Pick<PanelEditorValues, 'panelDefinition'> & {
  onDefinitionChange?: (definition: PanelDefinition) => void;
  height?: number;
};

export function PanelPreview({ panelDefinition, onDefinitionChange, height }: PanelPreviewProps) {
  if (panelDefinition.spec.plugin.kind === '') {
    return null;
  }

  return (
    <Container height={height ?? PANEL_PREVIEW_HEIGHT} disablePadding disableBorder>
      <Panel definition={panelDefinition} onDefinitionChange={onDefinitionChange} />
    </Container>
  );
}
